// group order 轮询时间间隔 10s
export const InterlvalTime = 10 * 1000;

export const PointBackValue = '5%';

export enum GroupOrderStatusEnum {
  'ACTIVE' = 'A'
}

export enum GroupOrderCartStatusEnum {
  ADDING = 'adding',
  SUBMITTED = 'submitted',
  PLACED = 'placed',
  CANCEL = 'cancel',
  FINISH = 'finish',
  CLOSE = 'close'
}
